// extracted by mini-css-extract-plugin
export default {"divider":"AttachPersonList_divider__dWlTw","personItem":"AttachPersonList_personItem__QCQi0","changeResponsibleBtn":"AttachPersonList_changeResponsibleBtn__Ztn3J"};